import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'normalize.css'
import './assets/scss/main.scss'

import Vuelidate from 'vuelidate'

import VueMask from 'v-mask'

Vue.use(Vuelidate)
Vue.use(VueMask)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
